import { render, staticRenderFns } from "./ChatTopMessage.vue?vue&type=template&id=5c8e5ea5&scoped=true"
import script from "./ChatTopMessage.vue?vue&type=script&lang=js"
export * from "./ChatTopMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatTopMessage.vue?vue&type=style&index=0&id=5c8e5ea5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e5ea5",
  null
  
)

export default component.exports